

//

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { App, Button, Form, Typography } from 'antd';
import { api } from '../api/client';

import { InputPassword } from '../components/Input';
import { InputConfirmPasswordWrapper, InputPasswordWrapper } from './Register';
import { API_CHANGE_PASSWORD, getEmail } from '../utils';
import { setSessionToken } from '../utils/session';
import { apiErrorMessage } from '../utils/apiErrors';

const { Text } = Typography;



export default function AccountChangePassword() {

	//

	const { message } = App.useApp();

	const [ oldPassword, setOldPassword ] = useState( '' );
	const [ newPassword, setNewPassword ] = useState( '' );
	const [ confirmPassword, setConfirmPassword ] = useState( '' );

	const [ newPasswordIsValid, setNewPasswordIsValid ] = useState( false );
	const [ confirmPasswordIsValid, setConfirmPasswordIsValid ] = useState( false );
	const [ saving, setSaving ] = useState( false );

	const navigate = useNavigate();



	const handleSave = () => {
		setSaving( true );
		api.put( API_CHANGE_PASSWORD, {
			oldPassword: oldPassword,
			newPassword: newPassword,
		} ).then( res => {
			// Every OTHER session is signed out by the change; the API hands this
			// device a fresh token so it stays signed in.
			if ( res.data?.token ) {
				// The same account: the session id is unchanged, so nothing resets.
				// From the phone app the answer is a new device session, refresh
				// credential included (KPR-1674).
				setSessionToken( res.data.token, { refreshToken: res.data.refreshToken || null } );
			}
			message.success( 'Your password has been updated. Other devices have been signed out.' );
			navigate( '/account' );
		}).catch( e => {
			message.error( apiErrorMessage( e, 'Your password did not update.' ) );
		} ).finally( () => setSaving( false ) );
	};



	const validateForm = () => {
		return oldPassword.length > 0
		&& newPasswordIsValid
		&& confirmPasswordIsValid;
	};



	return <>
		<h1>Change Password</h1>

		<p><Text type='secondary'>Changing your password signs out every other device. This one stays signed in.</Text></p>

		<Form className='m-1'>
			<input
				className='d-none'
				type='text'
				name='username'
				id='username'
				autoComplete='username'
				value={getEmail()}
				readOnly
				/>
			<InputPassword
				elementName={'oldPassword'}
				elementLabel={'Old password'}
				value={oldPassword}
				onChange={( name, value ) => setOldPassword( value )}
				autoComplete={'current-password'}
				/>
			<InputPasswordWrapper
				elementName={'newPassword'}
				elementLabel={'New password'}
				value={newPassword}
				onChange={( name, value ) => setNewPassword( value )}
				setPasswordIsValid={setNewPasswordIsValid}
				autoComplete={'new-password'}
				/>
			<InputConfirmPasswordWrapper
				elementName={'confirmPassword'}
				elementLabel={'Confirm password'}
				value={confirmPassword}
				onChange={( name, value ) => setConfirmPassword( value )}
				setConfirmPasswordIsValid={setConfirmPasswordIsValid}
				compareValue={newPassword}
				autoComplete={'confirm-password'}
				/>

			<Button onClick={handleSave} disabled={! validateForm()} loading={saving}>
				Save
			</Button>
		</Form>



	</>;

}
